export default {
  "nl": {
    "installment": {
      "actions": {
        "closeAllRows": "Sluit alle rijen",
        "deleteCount": "Je staat op het punt om {count} betaalschijf te verwijderen. Weet je het zeker? | Je staat op het punt {count} betaalschijven te verwijderen. Weet je het zeker?",
        "delete_installments": "Betalingsschijf verwijderen | Verwijder Betalingsschijven",
        "edit": "Bewerken",
        "newInstallment": "Nieuwe betalingsschijf",
        "openAllRows": "Open alle rijen",
        "publish": "Publiceer",
        "publishCustomer": "Publiceer...",
        "save": "Opslaan",
        "unpublish": "Depubliceer",
        "updateStatus": "Pas status aan",
        "uploadInvoice": "Upload factuur"
      },
      "attributes": {
        "amount": "Bedrag",
        "customer": "Klant",
        "due_date": "Deadline",
        "paid_at": "Betaald op",
        "status_deadline": "Status",
        "unit": "Unit"
      },
      "edit_actions": {
        "edit_amount": "bedragen",
        "edit_deadline": "Deadline",
        "edit_description": "Beschrijving",
        "edit_status": "Status"
      },
      "labels": {
        "changeStatusRequested": "Wijzig betalingsschijven van status 'In wacht' naar 'Aangevraagd'",
        "changeVisibility": "Verander zichtbaarheid",
        "change_amounts": "Wijzig bedragen",
        "countEdit": "Bewerk betalingsschijf voor 1 unit | Bewerk betalingsschijf voor {count} units",
        "created_at": "Aangemaakt op {created_at}",
        "deleteExplanation": "Alle betalingsschijven en facturen worden definitief van het platform verwijderd.",
        "deleteExplanationGroup": "Omdat je alle betaalschijven in deze groep wilt verwijderen, zal de groep ook verwijderd worden.",
        "details": "Details",
        "editDueDate": "Bewerk deadline",
        "editInstallmentTerm": "Bewerk betalingsschijf",
        "giveNewAmount": "Geef een nieuw bedrag",
        "goToUnitInstallments": "Ga naar unitbetalingsschijven",
        "invoices": "1 factuur | {count} facturen",
        "noDeadline": "Geen deadline",
        "notPublished": "Niet gepubliceerd",
        "paid": "Betaald",
        "published": "Gepubliceerd",
        "publishedCustomer": "Gepubliceerd voor klant",
        "publishingForCustomers": "Publiceer alle betaalschrijven van alle units. Ben je zeker?",
        "setDueDate": "Geef een deadline",
        "statusExplained": "Wat wil elke afbetalingsstatus betekenen?",
        "status_deadline": "Status",
        "statuses": {
          "draft": "In wacht",
          "expected": "Verwacht",
          "overdue": "Achterstallig",
          "paid": "Betaald",
          "requested": "Aangevraagd"
        },
        "toBePaid": "Nog te betalen",
        "total": "Totaal",
        "unitInstallmentsWillBeShownHere": "Betalingsschijven zullen hier getoond worden",
        "unpublishingForCustomers": "Depubliceer alle betaalschrijven voor alle units. Ben je zeker?",
        "updateStatusCount": "Pas betalingsstatus aan voor 1 betalingsschijf | Pas betalingsstatus aan voor {count} betalingsschijven",
        "uploadInvoiceCount": "Upload factuur voor 1 betalingsschijf | Upload factuur voor {count} betalingsschijven",
        "uploadInvoiceUnit": "Factuur uploaden naar {unit_name}",
        "vat": "BTW",
        "vat_with_percentage": "{percentage}% BTW",
        "view_list": "Lijst"
      },
      "legend": {
        "installmentDraft": "Betalingsschijf verwacht",
        "installmentDraftAfterDueDate": "Betalingsschijf verwacht",
        "installmentExpired": "Deadline verstreken",
        "installmentPaid": "Betalingsschijf betaald",
        "installmentPaidAfterDue": "Betalingsschijf betaald na deadline",
        "installmentRequested": "Betalingsschijf aangevraagd"
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Alle documenten gerelateerd aan betalingsschijven komen hier.",
            "title": "Nog geen documenten!"
          },
          "new": {
            "subtitle": "Nieuwe betalingsschijven komen er binnenkort!"
          }
        }
      },
      "sort_options": {
        "due_date": "Deadline",
        "group_name": "Naam",
        "status": "Status"
      },
      "validation": {
        "needNumber": "Moet een nummer zijn (bv. 8400.5)"
      }
    }
  }
}